import { useState } from 'react'

import { Container, StyledInput } from './styles'
import { Icon } from '../Icon'
import { CustomSpinner } from '../CustomSpinner'

export function CustomMask({ icon, size, isLoading, isDisabled, ...props }) {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <Container
      className="form-control"
      size={size}
      $isFocused={isFocused}
    >
      {isLoading ? (
        <CustomSpinner size={25} />
      ) : (
        icon && (
          <Icon
            iconName={icon}
            size={25}
            color={isFocused ? '#06357a' : ''}
          />
        )
      )}

      <StyledInput
        type="text"
        $isFocused={isFocused}
        onFocus={() => setIsFocused(true)}
        onBlurCapture={() => setIsFocused(false)}
        disabled={isLoading || isDisabled}
        {...props}
      />
    </Container>
  )
}
